import React, { Component, PureComponent } from 'react';
import * as _ from 'lodash';
import './Scorecard.css';
import ClientTable from './ClientTable';
import CsvDownload from './CsvDownload';
import Fmt from './Fmt';

class Scorecard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            filters: {csm: "all", am: "all", ecom: "all"},
            sort: {field: "arr_total", asc: false},
            search: "",
            page: {number: 0, size: 100}
        };

        this.addStateFromUrl(this.state);

        this.updateSearch = _.debounce(this.updateSearch, 50);

        this.updateCsm = this.updateCsm.bind(this);
        this.updateAm = this.updateAm.bind(this);
        this.updateEcom = this.updateEcom.bind(this);
        this.updateSortField = this.updateSortField.bind(this);
        this.updateSortDirection = this.updateSortDirection.bind(this);
        this.updateSearch = this.updateSearch.bind(this);
        this.updatePage = this.updatePage.bind(this);
    }

    addStateFromUrl(state) {
        const u = new URLSearchParams(window.location.search);
        if (u.get("csm")) state.filters.csm = u.get("csm");
        if (u.get("am")) state.filters.am = u.get("am");
        if (u.get("ecom")) state.filters.ecom = u.get("ecom");
        if (u.get("sort")) state.sort.field = u.get("sort");
        if (u.get("asc")) state.sort.asc = u.get("asc") === "true";
        if (u.get("search")) state.search = u.get("search");
        if (u.get("page")) state.page.number = Number(u.get("page"));
        if (u.get("size")) state.page.size = Number(u.get("size"));
    }

    setStateInUrl(state) {
        const u = new URLSearchParams("?");
        u.set("csm", state.filters.csm);
        u.set("am", state.filters.am);
        u.set("ecom", state.filters.ecom);
        u.set("sort", state.sort.field);
        u.set("asc", state.sort.asc);
        u.set("search", state.search);
        u.set("page", state.page.number);
        u.set("size", state.page.size);

        window.history.replaceState(null, null, window.location.pathname + "?" + u.toString());
    }

    updateCsm(evt) {
        const newVal = evt.target.value;
        this.updateState(s => s.filters.csm = newVal, true);
    }

    updateAm(evt) {
        const newVal = evt.target.value;
        this.updateState(s => s.filters.am = newVal, true);
    }

    updateEcom(evt) {
        const newVal = evt.target.value;
        this.updateState(s => s.filters.ecom = newVal, true);
    }

    updateSortField(evt) {
        const newVal = evt.target.value;
        this.updateState(s => s.sort.field = newVal, true);
    }

    updateSortDirection() {
        this.updateState(s => s.sort.asc = !s.sort.asc, true);
    }

    updateSearch(search) {
        // str.match(/("[^"]+"|[^"\s]+)/g); "foo \"bar baz\"" => foo, "bar baz"
        this.updateState(s => s.search = search, true);
    }

    updatePage(evt) {
        const newPage = evt.target.dataset.page;
        this.updateState(s => s.page.number = Number(newPage), false);
        window.scroll(0, 0);
    }

    updateState(mutationFunc, resetPaging) {
        this.setState((prevVal) => {
           const newState = _.cloneDeep(prevVal);
           mutationFunc(newState);

           if (resetPaging) {
               newState.page.number = 0;
           }

           return newState;
        });
    }

    componentDidUpdate() {
        this.setStateInUrl(this.state);
    }

    render() {
        console.log(JSON.stringify(this.state));
        const dm = this.props.dataManager;
        const md = dm.getMetadata();
        const fas = dm.getFilterAndSortOptions();

        const csmOptions = fas.filter_options.csm.map(c => <option key={c.value} value={c.value}>{c.name}</option>);
        const amOptions = fas.filter_options.am.map(c => <option key={c.value} value={c.value}>{c.name}</option>);
        const ecomOptions = fas.filter_options.ecom.map(c => <option key={c.value} value={c.value}>{c.name}</option>);
        const sortOptions = fas.sort_options.map(s => <option key={s.value} value={s.value}>{s.name}</option>);
        const sortDirIcon = this.state.sort.asc ? "fa-chevron-up" : "fa-chevron-down";

        const pageStart = this.state.page.number * this.state.page.size;
        const pageEnd = pageStart + this.state.page.size;

        const minUpdated = Fmt.dt(md.last_updated_min).toString();
        const maxUpdated = Fmt.dt(md.last_updated_max).toString();

        const data = dm.getData(this.state.filters, this.state.sort, this.state.search);

        const numPages = Math.ceil(data.length / this.state.page.size);
        const pageLinks = numPages === 1 ? null : _.range(numPages).map(i => {
            const cls = i === this.state.page.number ? "uk-active bold" : null;
            return <li key={i} className={cls}><a data-page={i} onClick={this.updatePage}>{i + 1}</a></li>
        });

        const pagedData = data.slice(pageStart, pageEnd);

        return (
            <div>
                <div className="uk-container filters-container">
                    <div className="filter-container filter-container-csm">
                        <div className="bold" htmlFor="sort-select">Sort</div>
                        <select id="sort-select" className="uk-select" value={this.state.sort.field} onChange={this.updateSortField}>
                            {sortOptions}
                        </select>
                        <span className={"icon-active fa " + sortDirIcon} onClick={this.updateSortDirection}></span>
                    </div>
                    <div className="filter-container">
                        <div className="bold" htmlFor="csm-select">Filter CSM</div>
                        <select id="csm-select" className="uk-select" value={this.state.filters.csm} onChange={this.updateCsm}>
                            {csmOptions}
                        </select>
                    </div>
                    <div className="filter-container">
                        <div className="bold" htmlFor="am-select">Filter AM</div>
                        <select id="csm-select" className="uk-select" value={this.state.filters.am} onChange={this.updateAm}>
                            {amOptions}
                        </select>
                    </div>
                    <div className="filter-container">
                        <div className="bold" htmlFor="ecom-select">Filter ECom</div>
                        <select id="ecom-select" className="uk-select" value={this.state.filters.ecom} onChange={this.updateEcom}>
                            {ecomOptions}
                        </select>
                    </div>
                    <div className="filter-container">
                        <div className="bold" htmlFor="search">Search</div>
                        <DebouncedTextbox className="uk-input" placeholder="Client Name" delay="650" value={this.state.search} onChange={this.updateSearch} />
                    </div>
                    <div>
                        <CsvDownload clientData={data} />
                    </div>
                </div>

                <div className="uk-container">
                    <ClientTable clientData={pagedData} />
                </div>
                <div className="uk-container footer">
                    <div className="small-text">
                        Last updated {minUpdated} - {maxUpdated}
                    </div>
                    <div className="small-text centered">
                        {Fmt.num(data.length)} clients, ${Fmt.num(_.chain(data).map(x => x.account.arr_prorated).sum().value())} in ARR
                    </div>
                    <ul className="uk-pagination" >
                        {pageLinks}
                    </ul>
                </div>

            </div>
        );
    }
}

class DebouncedTextbox extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {value: this.props.value};

        this.directCallback = this.props.onChange;
        this.debouncedCallback = _.debounce(this.props.onChange, this.props.delay);
        this.handleChange = this.handleChange.bind(this);
        this.handleClear = this.handleClear.bind(this);
    }

    handleChange(evt) {
        const newVal = evt.target.value;
        this.setState({value: newVal});
        this.debouncedCallback(newVal);
    }

    handleClear() {
        this.setState({value: ""});
        this.directCallback("");
    }

    render() {

        const clear = this.state.value === "" ? null : <span className="fa fa-close textbox-clear icon-active" onClick={this.handleClear} />

        return (
            <div style={{position: "relative"}}>
                {clear}
                <input className={this.props.className} placeholder={this.props.placeholder} type="text" value={this.state.value} onChange={this.handleChange} />
            </div>
        );
    }
}

export default Scorecard;


// WEBPACK FOOTER //
// ./src/Scorecard.js